<template lang="pug">
  v-row#filter-col-padding(no-gutters)
    v-col(cols='12')
      .textLabel.colorGrey
        | {{$t('chatHistoyFilter.lookForTheConversationIdentificationProtocol')}}
      v-text-field(
        hide-details
        filled
        dense
        v-model='service_code'
        placeholder='Protocolo')
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='conversation_id'
        placeholder='Conversation ID')
    v-col(cols='12' style='padding-bottom: 0;')
      .textLabel.colorDark(style='margin-top: 12px;')
        | {{$t('chatHistoyFilter.userFields')}}
      .textLabel.colorGrey
        | {{$t('chatHistoyFilter.searchByUsernameCpf')}}
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='user_name'
        :placeholder="$t('chatHistoyFilter.username')"
        prepend-inner-icon='mdi-account-outline')
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='cpfMasked'
        v-mask='["###.###.###-##", "##.###.###/####-##"]'
        :placeholder="$t('chatHistoyFilter.userIdentify')"
        prepend-inner-icon='mdi-card-account-details-outline')
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='phoneMasked'
        v-mask='["(##) ####-####", "(##) #####-####"]'
        :placeholder="$t('chatHistoyFilter.phoneNumber')"
        prepend-inner-icon='mdi-cellphone')
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='email'
        :placeholder="$t('chatHistoyFilter.email')"
        prepend-inner-icon='mdi-at')
    v-col(cols='12' style='padding-bottom: 0;')
      .textLabel.colorDark(style='margin-top: 12px;')
        | {{$t('chatHistoyFilter.conversationFields')}}
      .textLabel.colorGrey
        | {{$t('chatHistoyFilter.searchForCognitiveAssistant')}}
    //v-col(cols='12')
    //  v-text-field(
    //    hide-details
    //    filled
    //    dense
    //    v-model='bot'
    //    :placeholder="$t('chatHistoyFilter.cognitiveAssistant')"
    //    prepend-inner-icon='mdi-robot')
    v-col(cols='12')
      v-select(
        hide-details
        filled
        dense
        clearable
        :placeholder="$t('chatHistoyFilter.channel')"
        v-model='channelFilter'
        :items='channels'
        prepend-inner-icon='mdi-web'
        clear-icon='mdi-close'
        :label="$t('chatHistoyFilter.channel')"
        append-icon='mdi-chevron-down')
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='operator'
        :placeholder="$t('chatHistoyFilter.operator')"
        prepend-inner-icon='mdi-face-agent')
    v-col(cols='12')
      v-select(
        hide-details
        filled
        dense
        clearable
        :placeholder="$t('chatHistoyFilter.channel')"
        v-model='closedTo'
        :items='closedToList'
        prepend-inner-icon='mdi-comment-outline'
        :label="$t('chatHistoyFilter.finishedBy')"
        clear-icon='mdi-close'
        append-icon='mdi-chevron-down')
    v-col(cols='12')
      v-select(
        hide-details
        filled
        dense
        clearable
        :placeholder="$t('chatHistoyFilter.note')"
        v-model='evaluationFilter'
        :items='evaluation'
        prepend-inner-icon='mdi-star'
        :label="$t('chatHistoyFilter.evaluation')"
        clear-icon='mdi-close'
        append-icon='mdi-chevron-down')
        template(slot='item' slot-scope='{ item }')
          v-rating(:value='item * 5 ' size='12' dense length='5' color='#43a047' readonly)
        template(slot='selection' slot-scope='{ item }')
          v-rating(:value='item * 5 ' size='9' dense length='5' color='#43a047' readonly)
    v-col(cols='12' v-if='hasActiveWorkspace')
      v-combobox(
        hide-details
        filled
        dense
        clearable
        :placeholder="$t('chatHistoyFilter.intentions')"
        v-model='intentFilter',
        :items='intents'
        clear-icon='mdi-close'
        append-icon='mdi-chevron-down'
        hide-no-data)
    v-col(cols='12')
      v-text-field(
        hide-details
        filled
        dense
        v-model='group_name'
        :placeholder="$t('chatTable.queue')"
        prepend-inner-icon='mdi-view-sequential')
    v-col(cols='12')
      md-switch(v-model='group_toggle') Filtrar por filas não nulas
    v-col(v-if="isDataPrev || isSefMg")
      md-checkbox(v-model='activeFilter') Somente conversas ativas
</template>

<script>
import { mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { mask } from 'vue-the-mask'
import isTenantMixin from '@/components/mixins/isTenantMixin'
export default {
  directives: { mask },
  mixins: [isTenantMixin],
  computed: {
    ...mapFields('chatHistoryFilter', ['group_name', 'group_toggle', 'service_code', 'conversation_id', 'user_name', 'cpf', 'email', 'phone', 'bot', 'operator', 'closedTo', 'intents', 'channelFilter', 'evaluationFilter', 'intentFilter', 'activeFilter']),
    ...mapGetters('workspaces', ['active']),
    ...mapGetters('snapshots', ['appliedSnapshot']),
    hasActiveWorkspace () {
      return this.active ? (this.appliedSnapshot ? 1 : 0) : 0
    }
  },
  watch: {
    cpfMasked (nV) {
      this.cpf = nV.replace('.', '').replace('-', '').replace('/', '').replace('.', '')
    },
    phoneMasked (nV) {
      this.phone = nV.replace('(', '').replace(')', '').replace('-', '').replace(' ', '')
    }
  },
  data () {
    return {
      channels: ['webclient', 'whatsapp', 'teams', 'facebook', 'instagram', 'sms'],
      closedToList: ['operator', 'user', 'inactivity'],
      evaluation: [1, 0.8, 0.6, 0.4, 0.2, 0],
      cpfMasked: undefined,
      phoneMasked: undefined
    }
  },
  methods: {
    async getIntents () {
      const result = await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/snapshots`, {
        params: {
          workspace: this.active.id,
          status: 'published',
          fields: 'data.intents.intent'
        }
      })
      this.intents = result.data.data[0]._source.data.intents.map((obj) => obj.intent)
    }
  },
  mounted () {
    if (this.hasActiveWorkspace) {
      this.getIntents()
    }
  }
}
</script>

<style lang="scss">

  .v-input__prepend-inner {
    margin-right: auto;
    padding-right: 8px;
  }
  #filter-col-padding .col {
    padding: 8px;
  }

  .v-input--checkbox {

    ::v-deep label {
      margin-left: 5px;
    }
    ::v-deep .v-input--selection-controls__input {
      margin-left: 5px !important;
    }
  }

  .md-switch-label {
    color: #393939 !important;
  }

</style>
